module.exports = __webpack_public_path__ + "img/ic_quality.cf5f4d57.png";